import { NAME } from './constants';

export const INIT_CATEGORIES = `${NAME}/INIT_CATEGORIES`;
export const INIT_SHIPPERS = `${NAME}/INIT_SHIPPERS`;
export const SEARCH = `${NAME}/SEARCH`;
export const CANCEL = `${NAME}/CANCEL`;
export const PREPARE_PRE_BOOK = `${NAME}/PREPARE_PRE_BOOK`;
export const DESTROY_PRE_BOOK = `${NAME}/DESTROY_PRE_BOOK`;
export const SET_BOOKING_STEP = `${NAME}/SET_BOOKING_STEP`;
export const PRE_BOOK = `${NAME}/SHIPMENT_PRE_BOOK`;
